import { defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "placeholder"]

import { PropType } from "vue";
import { FormValue } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: {
    item: {
        type: Object,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    type: __props.item.type,
    placeholder: __props.item.label,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value[__props.item.key]) = $event))
  }, null, 8, _hoisted_1)), [
    [_vModelDynamic, __props.value[__props.item.key]]
  ])
}
}

})